var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3147 8.00095C13.3147 9.67474 11.9572 11.0312 10.2834 11.0312C8.60965 11.0312 7.25317 9.67474 7.25317 8.00095C7.25317 6.3262 8.60965 4.96973 10.2834 4.96973C11.9572 4.96973 13.3147 6.3262 13.3147 8.00095Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2819 15C13.9324 15 17.2714 12.3752 19.1512 8C17.2714 3.62476 13.9324 1 10.2819 1H10.2857C6.63523 1 3.29628 3.62476 1.41638 8C3.29628 12.3752 6.63523 15 10.2857 15H10.2819Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionVisit);
export default __webpack_public_path__ + "static/media/action-visit.600ce126184e2a5c5fb21c1e4f5617fa.svg";
export { ForwardRef as ReactComponent };